var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlassCut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MagnifyingGlassCut") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 22c-.27 0-.53-.11-.73-.31l-7.33-7.76a.991.991 0 010-1.36 6.296 6.296 0 001.66-4.26c0-3.47-2.83-6.3-6.3-6.3C4.83 2.01 2 4.83 2 8.3s2.83 6.3 6.3 6.3c.67 0 1.34-.11 1.97-.32a.993.993 0 011.26.64.997.997 0 01-.64 1.26c-.84.28-1.71.42-2.6.42C3.72 16.6 0 12.87 0 8.3S3.72 0 8.3 0s8.3 3.72 8.3 8.3c0 1.77-.56 3.48-1.6 4.89l6.73 7.12a.996.996 0 01-.73 1.68V22z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlassCut);
export default __webpack_public_path__ + "static/media/MagnifyingGlassCut.ad64159b0a966f569d89d3ac37054034.svg";
export { ForwardRef as ReactComponent };